export function formatINR(amount: number | string, decimals = false): string {
  const num = typeof amount === 'number' ? amount : parseFloat(String(amount).replace(/[^0-9.-]/g, '')) || 0;
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: decimals ? 2 : 0,
  }).format(num);
}

export function formatRupees(amount: number | string): string {
  const num = typeof amount === 'number' ? amount : parseFloat(String(amount).replace(/[^0-9.-]/g, '')) || 0;
  return `₹${num.toLocaleString('en-IN')}`;
}

